import { render, staticRenderFns } from "./UploadProgressFiles.vue?vue&type=template&id=45cfe18a&"
import script from "./UploadProgressFiles.vue?vue&type=script&lang=js&"
export * from "./UploadProgressFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports